const filterRegExp = (txt:string)=>{
    if(txt === undefined) return ""
    if(txt === null) return  ""
    return txt.replace(/[[\]\\^$.|?*+()]/uig,"")

}
export default filterRegExp